<template>
  <div>
    <div class="headView">
      <div class="headView_top">
        <p class="applyTitle">项目名称：{{ project.project_name }}</p>
        <!-- <button type="button" @click="showScore">初审打分</button> -->
      </div>
      <div class="headClass">
        <p>项目类型：{{ project.project_type_name }}</p>
        <p>申请时间：{{ project.apply_start }}-{{ project.apply_end }}</p>
        <p>审核时间：{{ project.app_start }}-{{ project.app_end }}</p>
      </div>
    </div>
    <!-- 申报审核通用封装组件 -->
    <div class="content_view">
      <div class="contentLeft">
        <p
          v-for="(item, index) in navList"
          v-show="navList[index]"
          :key="index"
          @click="changeTab(index)"
          :class="navIndex === index ? 'tabActive' : ''"
        >
          {{ item }}
        </p>
      </div>
      <div class="contentRight">
        <div v-show="navIndex == 0">
          <p class="view_head">申报通知</p>
          <!-- pdf -->
          <pdfVue v-if="require_pdf_url" :pdf_url="require_pdf_url"></pdfVue>
        </div>
        <div v-show="navIndex == 1">
          <p class="view_head">评选标准</p>
          <!-- pdf -->
          <pdfVue
            v-if="selection_pdf_url"
            :pdf_url="selection_pdf_url"
          ></pdfVue>
        </div>
        <div v-show="navIndex == 2">
          <p class="view_head">
            申请书
          </p>
          <div class="inputList">
            <!-- 非优质安装工程基本信息 -->
            <ChengXinCompany :basicMsg="basicMsg"> </ChengXinCompany>
          </div>
        </div>

        <!--                <div class="" v-show="navIndex == 3">
                    <div>
                        <p class="view_head">资质</p>
                        <div style="display: flex;flex-wrap: wrap;margin-top: 20px;" v-for="(item,index) in award">

                            <div class="inputList">
                                <labelText :spanTitle= " '资质类别' + (index+1)" v-if="item.qualification_category" :spanWidth="spanWidth"
                                           componentWidth="1060px" :pContent="item.qualification_category">
                                </labelText>
                                <labelText spanTitle="等级" :spanWidth="spanWidth" componentWidth="520px"
                                           :pContent="item.qualification_level">
                                </labelText>
                                <labelText spanTitle="证书编号" :spanWidth="spanWidth" componentWidth="520px"
                                           :pContent="item.certificate_no">
                                </labelText>
                                <labelText spanTitle="有效期" :spanWidth="spanWidth" componentWidth="520px"
                                           :pContent="item.effective_time">
                                </labelText>
                            </div>
                        </div>
                    </div>

                </div>-->

        <div class="uploadContent" v-show="navIndex == 3">
          <p class="view_head">北京建设行业诚信企业评价计分表</p>

          <el-form :model="valForm" ref="valRef">
            <div>
              <table border="1" class="newtable">
                <thead>
                  <tr>
                    <th rowspan="2">项目</th>
                    <th rowspan="2">评价内容</th>
                    <th rowspan="2">评价标准</th>
                    <th rowspan="2">分值</th>
                    <th rowspan="2">评价计分</th>
                    <th colspan="3">评分</th>
                  </tr>
                  <tr>
                    <th>自评分</th>
                    <th>初评分</th>
                    <th>审定分</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- 基本素质 -->
                  <tr>
                    <td rowspan="10">一、基本素质（30分）</td>
                    <td>1、资质及资格</td>
                    <td>具有企业法人营业执照、资质证书、安全生产许可证</td>
                    <td>6分</td>
                    <td>
                      1、均在有效期内，计6分；<br />2、有一项不在有效期内，计0分。
                    </td>
                    <td>
                      <el-form-item>
                        <el-input-number
                          :max="6"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen1"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td rowspan="3">2、组织机构及制度建设</td>
                    <td>组织机构健全</td>
                    <td rowspan="3">9分</td>
                    <td rowspan="3">
                      1、组织机构健全，计3分；<br />2、规章制度健全，计3分；<br />3、上述运行有效果，计3分。
                    </td>
                    <td rowspan="3">
                      <el-form-item>
                        <el-input-number
                          :max="9"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen2"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td rowspan="3"></td>
                    <td rowspan="3"></td>
                  </tr>
                  <tr>
                    <td>规章制度健全</td>
                  </tr>
                  <tr>
                    <td>运行有效</td>
                  </tr>
                  <!-- 注意：这里只列出了部分行作为示例，完整表格需要继续添加剩余的行 -->

                  <!-- 管理体系认证 -->
                  <tr>
                    <td rowspan="2">3、管理体系认证</td>
                    <td>
                      具有质量管理体系、环境管理体系、职业健康安全管理体系认证证书
                    </td>
                    <td rowspan="2">9分</td>
                    <td rowspan="2">
                      1、三类管理体系认证证书均在有效期内，计4.5分；<br />2、三类管理体系认证证书，每少一项少计1.5分；<br />3、三类管理体系年度审核合格报告齐全，计4.5分；<br />4、三类管理体系年度审核合格报告，少一项少计1.5分。
                    </td>
                    <td rowspan="2">
                      <el-form-item>
                        <el-input-number
                          :max="9"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen3"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td rowspan="2"></td>
                    <td rowspan="2"></td>
                  </tr>
                  <tr>
                    <td>
                      具有质量管理体系、环境管理体系、职业健康安全管理体系年度审核合格报告
                    </td>
                  </tr>

                  <!-- 人员配置 -->
                  <tr>
                    <td rowspan="4">4、人员配置</td>
                    <td>管理和技术人员配置齐全、合理</td>
                    <td rowspan="4">6分</td>
                    <td rowspan="4">
                      1、人员配置合理，计3分；<br />2、大专（含）以上学历者符合要求，计1分；<br />3、一级注册建造师符合要求，计1分；<br />4、二级注册建造师符合要求，计1分。
                    </td>
                    <td rowspan="4">
                      <el-form-item>
                        <el-input-number
                          :max="6"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen4"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td rowspan="4"></td>
                    <td rowspan="4"></td>
                  </tr>
                  <tr>
                    <td>大专以上学历者大于人员总数的50%</td>
                  </tr>
                  <tr>
                    <td>上述人员中，一级注册建造师须符合岗位资格规定</td>
                  </tr>
                  <tr>
                    <td>上述人员中，二级注册建造师须符合岗位资格规定</td>
                  </tr>

                  <tr>
                    <td rowspan="5">二、经济指标 （30分）</td>
                    <td>1、企业净资产</td>
                    <td>符合资质的相应标准</td>
                    <td>6分</td>
                    <td>
                      1、达到标准，计6分；<br />2、低于相应标准10%（含10%）以内，计3分；<br />3、低于相应标准10%以上，计0分。
                    </td>
                    <td>
                      <el-form-item>
                        <el-input-number
                          :max="6"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen5"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>2、工程结算收入</td>
                    <td>满足企业良性运行需求</td>
                    <td>6分</td>
                    <td>
                      1、满足企业良性运行需求，计6分；<br />2、不能满足企业良性运行需求，计0分。
                    </td>
                    <td>
                      <el-form-item>
                        <el-input-number
                          :max="6"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen6"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>3、净资产增长率</td>
                    <td>增长率≧3%</td>
                    <td>6分</td>
                    <td>
                      1、达到标准，计6分；<br />2、每降低1%，少计1分；<br />3、小于0%，计0分。
                    </td>
                    <td>
                      <el-form-item>
                        <el-input-number
                          :max="6"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen7"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>4、资产负债率</td>
                    <td>负债率≦75%</td>
                    <td>6分</td>
                    <td>
                      1、达到标准，计6分；<br />2、每增加5%，少计1分；<br />3、负债率≥95%，计0分。
                    </td>
                    <td>
                      <el-form-item>
                        <el-input-number
                          :max="6"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen8"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>5、利润率</td>
                    <td>利润率≧1.5%</td>
                    <td>6分</td>
                    <td>
                      1、达到标准，计6分；<br />2、每减少0.5%，少计1分；<br />3、小于0%，计0分。
                    </td>
                    <td>
                      <el-form-item>
                        <el-input-number
                          :max="6"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen9"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>

                  <!-- 施工合同管理 -->
                  <tr>
                    <td rowspan="21">三、企业管理（40分）</td>
                    <td rowspan="2">1、施工合同管理</td>
                    <td>依法签订施工合同</td>
                    <td rowspan="2">5分</td>
                    <td rowspan="2">
                      1、达到标准，计5分；<br />2、未达到标准，计0分。
                    </td>
                    <td rowspan="2">
                      <el-form-item>
                        <el-input-number
                          :max="5"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen10"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td rowspan="2"></td>
                    <td rowspan="2"></td>
                  </tr>
                  <tr>
                    <td>施工合同管理履约率100%</td>
                  </tr>

                  <!-- 工程质量管理 -->
                  <tr>
                    <td rowspan="2">2、工程质量管理</td>
                    <td>有健全的质量管理体系和质量管理部门</td>
                    <td rowspan="2">6分</td>
                    <td rowspan="2">
                      1、有健全的质量管理机构和专职的质量管理人员，计3分；<br />2、工程质量合格率100%，计3分。
                    </td>
                    <td rowspan="2">
                      <el-form-item>
                        <el-input-number
                          :max="6"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen11"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td rowspan="2"></td>
                    <td rowspan="2"></td>
                  </tr>
                  <tr>
                    <td>工程质量合格率100%</td>
                  </tr>

                  <!-- 绿色、安全施工管理 -->
                  <tr>
                    <td rowspan="2">3、绿色、安全施工管理</td>
                    <td>有健全安全生产的管理体系和专职的安全管理部门</td>
                    <td rowspan="2">6分</td>
                    <td rowspan="2">
                      1、安全管理达到评价标准，计4分；<br />2、绿色低碳施工管理达到标准，计2分。
                    </td>
                    <td rowspan="2">
                      <el-form-item>
                        <el-input-number
                          :max="6"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen12"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td rowspan="2"></td>
                    <td rowspan="2"></td>
                  </tr>
                  <tr>
                    <td>有健全的绿色低碳施工管理体系</td>
                  </tr>

                  <!-- 材料设备采购管理 -->
                  <tr>
                    <td rowspan="2">4、材料设备采购管理</td>
                    <td>有健全的材料设备管理制度</td>
                    <td rowspan="2">4分</td>
                    <td rowspan="2">
                      1、制度健全，计2分；<br />2、符合国家相关标准的要求，计2分。
                    </td>
                    <td rowspan="2">
                      <el-form-item>
                        <el-input-number
                          :max="4"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen13"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td rowspan="2"></td>
                    <td rowspan="2"></td>
                  </tr>
                  <tr>
                    <td>材料、设备符合国家相关标准的要求</td>
                  </tr>

                  <!-- 人力资源管理 -->
                  <tr>
                    <td rowspan="4">5、人力资源管理</td>
                    <td>
                      依法与员工签订劳动合同，建立并实行员工绩效考核与激励机制
                    </td>
                    <td rowspan="4">4分</td>
                    <td rowspan="4">1、达到每项评价标准，计1分</td>
                    <td rowspan="4">
                      <el-form-item>
                        <el-input-number
                          :max="4"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen14"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td rowspan="4"></td>
                    <td rowspan="4"></td>
                  </tr>
                  <tr>
                    <td>职工教育经费/工资总额>1.5%</td>
                  </tr>
                  <tr>
                    <td>依法与劳务队签订劳务分包合同，做到实名制管理</td>
                  </tr>
                  <tr>
                    <td>
                      按时支付劳动者（含劳务队）报酬，按规定为劳动者（含劳务队）办理保险
                    </td>
                  </tr>

                  <tr>
                    <td>6、标准化管理</td>
                    <td>
                      具有符合现代化企业要求的技术和管理标准，实施标准化管理
                    </td>
                    <td>3分</td>
                    <td>达到评价标准，计3分</td>
                    <td>
                      <el-form-item>
                        <el-input-number
                          :max="3"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen15"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>

                  <tr>
                    <td>7、企业发展战略</td>
                    <td>
                      具有规划科学、目标明确、具有可操作性的中长期发展战略（规划）
                    </td>
                    <td>3分</td>
                    <td>达到评价标准，计3分</td>
                    <td>
                      <el-form-item>
                        <el-input-number
                          :max="3"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen16"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td rowspan="3">8、技术创新管理</td>
                    <td>有技术研发机构和专业人员</td>
                    <td rowspan="3">3分</td>
                    <td rowspan="3">
                      1、有技术研发机构和专业人员，计1分；<br />
                      2、有技术创新规划或年度创新安排，计1分；<br />
                      3、有年度创新成果，如创新绿色低碳技术、创新绿色低碳施工工法，并纳入绿色低碳筛选名录或
                      QC 成果、专利等，计1分。
                    </td>
                    <td rowspan="3">
                      <el-form-item>
                        <el-input-number
                          :max="3"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen17"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td rowspan="3"></td>
                    <td rowspan="3"></td>
                  </tr>
                  <tr>
                    <td>有技术创新规划或年度创新安排</td>
                  </tr>
                  <tr>
                    <td>有年度创新成果</td>
                  </tr>
                  <tr>
                    <td>9、研发投入</td>
                    <td>
                      研发费用率：<br />特级企业≥0.5%；一级企业≥0.4%；二级企业≥0.3%
                    </td>
                    <td>2分</td>
                    <td>
                      1、达到评价标准，计2分；<br />2、每降低0.2%，少计1分。
                    </td>
                    <td>
                      <el-form-item>
                        <el-input-number
                          :max="2"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen18"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td rowspan="3">10、信息化建设管理</td>
                    <td>建成并使用办公自动化 OA 系统</td>
                    <td rowspan="3">4分</td>
                    <td rowspan="3">
                      1、建成并使用办公自动化 OA 系统，计2分；<br />
                      2、搭建并运营企业（单位）官方网站，计1分；<br />
                      3、工程项目全面推广 BIM 技术应用，计1分。
                    </td>
                    <td rowspan="3">
                      <el-form-item>
                        <el-input-number
                          :max="4"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen19"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td rowspan="3"></td>
                    <td rowspan="3"></td>
                  </tr>
                  <tr>
                    <td>搭建并运营企业（单位）官方网站</td>
                  </tr>
                  <tr>
                    <td>工程项目全面推广 BIM 技术应用</td>
                  </tr>

                  <tr>
                    <td rowspan="32">优良信息(加分项)</td>
                    <td rowspan="12">1、质量奖</td>
                    <td>中国建设工程鲁班奖</td>
                    <td rowspan="6">国家级2分</td>
                    <td rowspan="6">
                      1、总承包单位获得3个及以上，计2分；
                      <br />2、总承包单位获得1-2个，计1分；
                      <br />3、参建单位获得3个及以上，计1.5分；
                      <br />4、参建单位获得1-2个，计0.5分； <br />5、满分2分。
                    </td>
                    <td rowspan="6">
                      <el-form-item>
                        <el-input-number
                          :max="2"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen20"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td rowspan="6"></td>
                    <td rowspan="6"></td>
                  </tr>
                  <tr>
                    <td>中国土木工程詹天佑奖</td>
                  </tr>
                  <tr>
                    <td>中国土木工程詹天佑奖优秀住宅小区金奖</td>
                  </tr>
                  <tr>
                    <td>国家优质工程奖</td>
                  </tr>
                  <tr>
                    <td>中国钢结构金奖</td>
                  </tr>
                  <tr>
                    <td>其他全国性工程奖（中国安装之星等）</td>
                  </tr>
                  <tr>
                    <td>北京市建筑（长城）优质工程</td>
                    <td rowspan="6">省部级3分</td>
                    <td rowspan="6">
                      1、总承包单位获得3个及以上，计3分；<br />
                      2、总承包单位获得1-2个，计2分；<br />
                      3、参建单位获得奖项，计1分；<br />
                      4、获得区级优质工程奖，计1分；<br />
                      5、满分3分。
                    </td>
                    <td rowspan="6">
                      <el-form-item>
                        <el-input-number
                          :max="3"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen21"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td rowspan="6"></td>
                    <td rowspan="6"></td>
                  </tr>
                  <tr>
                    <td>北京市市政基础设施（长城）优质工程</td>
                  </tr>
                  <tr>
                    <td>北京市建筑装饰优质工程奖</td>
                  </tr>
                  <tr>
                    <td>北京市安装工程优质奖</td>
                  </tr>
                  <tr>
                    <td>其他省部级优质工程奖</td>
                  </tr>
                  <tr>
                    <td>北京市区级优质工程奖</td>
                  </tr>

                  <tr>
                    <td rowspan="3">2、安全奖</td>
                    <td>全国建设工程项目施工安全生产标准化工地</td>
                    <td>国家级1分</td>
                    <td>
                      获得1个及以上，计1分。
                    </td>
                    <td>
                      <el-form-item>
                        <el-input-number
                          :max="1"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen22"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>

                  <tr>
                    <td>北京市绿色安全工地</td>
                    <td rowspan="2">北京市级2分</td>
                    <td rowspan="2">
                      1、获得样板工地2个及以上，计2分；<br />
                      2、获得样板工地1个，计1分；<br />
                      3、获得绿色安全工地3个及以上，计2分；<br />
                      4、获得绿色安全工地1-2个，计1分；<br />
                      5、满分2分。
                    </td>
                    <td rowspan="2">
                      <el-form-item>
                        <el-input-number
                          :max="2"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen28"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>

                  <tr>
                    <td>北京市绿色安全样板工地</td>

                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>

                  <tr>
                    <td rowspan="13">3、科技进步奖</td>
                    <td>国家科学技术奖</td>
                    <td rowspan="7">国家级2分</td>
                    <td rowspan="7">
                      1、获得3个及以上，计2分；<br />
                      2、获得1-2个，计1分；<br />
                      3、满分2分。
                    </td>
                    <td rowspan="7">
                      <el-form-item>
                        <el-input-number
                          :max="2"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen23"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td rowspan="7"></td>
                    <td rowspan="7"></td>
                  </tr>
                  <tr>
                    <td>全国绿色建筑创新奖</td>
                  </tr>
                  <tr>
                    <td>华夏建设科学技术奖</td>
                  </tr>
                  <tr>
                    <td>全国市政金杯示范工程</td>
                  </tr>
                  <tr>
                    <td>
                      住建部科技计划项目（装配式建筑示范项目、绿色施工科技示范项目）
                    </td>
                  </tr>
                  <tr>
                    <td>国家级工法</td>
                  </tr>
                  <tr>
                    <td>国家或行业标准</td>
                  </tr>

                  <tr>
                    <td>北京市科学技术奖</td>
                    <td rowspan="6">北京市级2分</td>
                    <td rowspan="6">
                      1、获得3个及以上，计2分；<br />
                      2、获得1-2个，计1分；<br />
                      3、满分2分。
                    </td>
                    <td rowspan="6">
                      <el-form-item>
                        <el-input-number
                          :max="2"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen24"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td rowspan="6"></td>
                    <td rowspan="6"></td>
                  </tr>

                  <tr>
                    <td>北京市科技成果鉴定</td>
                  </tr>
                  <tr>
                    <td>北京市建筑业新技术应用示范工程</td>
                  </tr>
                  <tr>
                    <td>北京市建筑信息模型（BIM)技术应用示范工程</td>
                  </tr>
                  <tr>
                    <td>北京市级工法</td>
                  </tr>
                  <tr>
                    <td>北京地方标准、团体标准</td>
                  </tr>

                  <tr>
                    <td rowspan="2">
                      4、个人荣誉
                    </td>
                    <td>
                      企业员工荣获劳动模范、五一劳动奖章
                    </td>
                    <td>
                      1分
                    </td>

                    <td>
                      1、国家级一个1分；<br />
                      2、北京市级一个0.5分；<br />
                      3、满分1分。
                    </td>
                    <td>
                      <el-form-item>
                        <el-input-number
                          :max="1"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen25"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>
                      优秀项目经理、优秀建造师、茅以升科学技术奖--建造师奖
                    </td>
                    <td>
                      4分
                    </td>

                    <td>
                      荣获有效期内的北京市优秀项目经理、优秀建造师、茅以升科学技术奖——建造师奖：<br />
                      1、总承包特级及一级资质企业每十个名额得1分；<br />
                      2、总承包一级以下及专业资质企业每五个名额得1分；<br />
                      3、茅以升科学技术奖——建造师奖每个名额得0.5分，满分1分；<br />
                      3、满分4分。
                    </td>
                    <td>
                      <el-form-item>
                        <el-input-number
                          :max="4"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen29"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>

                  <tr>
                    <td>
                      5、社会责任信息
                    </td>
                    <td>
                      公益活动：向社会捐赠、捐献、扶困、义工等；或完成省、直辖市（含）以上下达的援建抢险救灾等任务
                    </td>
                    <td>
                      3分
                    </td>

                    <td>
                      可提交相关收据或含有企业名称的文件、新闻报道、感谢信等文件，满足其一计3分
                    </td>
                    <td>
                      <el-form-item>
                        <el-input-number
                          :max="3"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen30"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>
                      附加项
                    </td>
                    <td>
                      积极组织供应商参加北京市建筑行业绿色低碳信用评价活动
                    </td>
                    <td>
                      5分
                    </td>

                    <td>
                      1、推荐5-10家，计2.5分；<br />
                      2、推荐10家及以上，计5分；<br />
                      3、满分5分。
                    </td>
                    <td>
                      <el-form-item>
                        <el-input-number
                          :max="5"
                          :min="0"
                          @change="calsum"
                          v-model="valForm.fen31"
                          :controls="false"
                        ></el-input-number>
                      </el-form-item>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>

                  <tr>
                    <td rowspan="2">
                      不良信息(扣分项）
                    </td>
                    <td rowspan="2">
                      负面记录
                    </td>
                    <td>
                      企业在行业的信用信息<br />
                      "全国建筑市场监管公共服务平台""北京市建筑市场信用信息监管平台"等披露的相关信息。
                    </td>

                    <td></td>

                    <td rowspan="2">
                      行政处罚或不良行为信息，满3次扣1分，不满3次扣0.5分，扣分无上限（同一处罚不重复扣分）
                    </td>
                    <td>
                      <el-form-item>
                        <el-input-number
                          :max="0"
                          :min="-10000"
                          @change="calsum"
                          v-model="valForm.fen26"
                          :controls="false"
                        ></el-input-number>
                        <p style="font-size: 12px;line-height: 18px;color: red">
                          此分数为扣分项，请填写负数，如无处罚，请填写“0”
                        </p>
                      </el-form-item>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>

                  <tr>
                    <td>
                      企业的综合信用信息<br />"国家企业信用信息公示系统""信用中国""中国执行信息公开网"等披露的相关信息。
                    </td>
                    <td></td>
                    <td>
                      <el-form-item>
                        <el-input-number
                          :max="0"
                          :min="-10000"
                          @change="calsum"
                          v-model="valForm.fen27"
                          :controls="false"
                        ></el-input-number>
                        <p style="font-size: 12px;line-height: 18px;color: red">
                          此分数为扣分项，请填写负数，如无处罚，请填写“0”
                        </p>
                      </el-form-item>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>

                  <tr>
                    <td colspan="5" style="text-align: center !important;">
                      总计
                    </td>
                    <td>{{ totalpoint }}</td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="uploadBtn">
              <el-button type="primary" @click="savePdbForm">保存</el-button>
            </div>
          </el-form>
        </div>
        <!-- 优秀项目经理显示资料上传 -->
        <div class="newTab" v-show="navIndex == 4">
          <!--<div class="uploadHead" @click="upShow('muban')">
                        <img :src="numbanDoload" style="width: 20px;height: 20px;">
                        <p>模板下载</p>
                    </div>-->
          <p class="view_head">资料上传</p>

          <div style="display: flex;justify-content: flex-end">
            <img
              :src="require('@/assets/img/main/download.png')"
              style="width: 20px;height: 20px;"
            />
            <p @click="downLoadFile" style="margin-right: 20px;">
              点击下载申请书
            </p>
          </div>

          <div
            class="uploadList"
            v-for="(item, index) in uploadData.title"
            :key="index"
          >
            <div class="uploadList_head">
              <p>{{ item }}</p>

              <!-- 开启上传 -->
              <div class="head_list" v-if="changeInput">
                <img :src="uploadImg" style="width: 20px;height: 20px;" />
                <p @click="upShow('upload', index)">点击上传</p>
              </div>
            </div>
            <div class="uploadList_mid">
              <p>{{ uploadData.tips[index] }}</p>
            </div>
            <div class="uploadList_bot">
              <div
                class="inner_upload"
                v-for="(item, key) in uploadList[index]"
                :key="key"
                @click="navTo(item)"
              >
                <p>{{ item.data_name ? item.data_name : item.name }}</p>
                <img
                  v-if="changeInput"
                  src="@/assets/img/login/cuowu.png"
                  @click.stop="deleteUpload(key, index)"
                />
              </div>
              <!-- <p v-for="(item,key) in uploadList[index]" :key="key" @click="navTo(item)">
                                {{item.data_name?item.data_name:item.name}}
                            </p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  <div class="uploadBtn" v-if="navIndex == 2 && changeInput">
            <el-button type="primary" @click="setBasicInfo">保存</el-button>
        </div>

        <div class="uploadBtn" v-if="navIndex == 4 && changeInput" style="display: flex;flex-flow: column;">
            <div class="content_btn">
                <p>资料上传后请点击保存</p>
            </div>
            <el-button type="primary" @click="setUploadFile">保存</el-button>
        </div>-->

    <!-- 弹窗 -->
    <addDialog ref="download" @submitSuccess="submitSuccess"></addDialog>
    <!-- 弹窗 -->
    <feedDetail ref="feedDetail"></feedDetail>
    <!-- <scoreDialog ref="scoredialog" @chooseDetail="chooseDetail"></scoreDialog> -->
  </div>
</template>

<script>
import { getApplicationDetail } from "@/api/moudles/management.js";
import {
  getDataItem,
  sureUpdate,
  setBasicProgram,
  getUploadFile,
} from "@/api/moudles/manager.js";
import { API_DOMAIN } from "@/api/api.js";
import pdfVue from "./components/pdfVue.vue";
import labelInput from "@/components/table/labelInput.vue";
import labelText from "@/components/table/labelText.vue";
import scoreDialog from "../components/scoreDialog.vue";
import addDialog from "./components/addDialog.vue";
import feedDetail from "../components/feedDetail.vue";
import normalTable from "@/components/table/normalTable.vue";
import normalSelect from "@/components/table/normalSelect.vue";
import upload_img from "@/assets/img/main/upload.png";
import muban_doload from "@/assets/img/main/muban.png";
import ChengXinCompany from "./components/ChengXinCompany";

export default {
  data() {
    return {
      valForm: {
        fen1: "",
        fen2: "",
        fen3: "",
        fen4: "",
        fen5: "",
        fen6: "",
        fen7: "",
        fen8: "",
        fen9: "",
        fen10: "",
        fen11: "",
        fen12: "",
        fen13: "",
        fen14: "",
        fen15: "",
        fen16: "",
        fen17: "",
        fen18: "",
        fen19: "",
        fen20: "",
        fen21: "",
        fen22: "",
        fen23: "",
        fen24: "",
        fen25: "",
        fen26: "",
        fen27: "",
        fen28: "",
      },
      project_code: "",
      totalpoint: "",
      project_app_num: "",
      // 上传文件列表
      clickIndex: 0,
      uploadImg: upload_img,
      numbanDoload: muban_doload,
      // 参建单位
      addList: [],
      // 参建方式
      installList: [
        [
          {
            name: "建设单位",
            code: "建设单位",
          },
          {
            name: "设计单位",
            code: "设计单位",
          },
          {
            name: "监理单位",
            code: "监理单位",
          },
          {
            name: "其他施工单位",
            code: "其他施工单位",
          },
        ],
      ],
      changeInput: false,
      allList: "",
      dataList: "",
      oldAddList: [],
      // 修改意见
      tabList: ["反馈时间", "意见详情", "修改状态", "修改时间", "动作"],
      tableList: [],
      codeList: [],

      basicMsg: {},
      id: "",
      project: "",
      award: "",
      navIndex: 0,
      spanWidth: "180px",
      navList: [
        "申报通知",
        "评选标准",
        "申请书",
        /* "资质",*/
        "评价表",
        "资料上传",
      ],
      // 基础信息表单加内容
      basicInfo: [],
      formName: {
        name: "姓名",
        id_card: "身份证号码",
        birth_date: "出生年月",
        education: "学历",
        join_work_time: "参加工作时间",
        title: "职称",
        major: "建造师专业",
        level: "建造师等级",
        req_number: "注册编号",
        post: "获奖工程所从事职务",
        tellphone: "本人联系电话",
        department: "单位主管部门",
        enp_contacts: "单位联系人",
        enp_contacts_phone: "联系电话",
        continue_edu_year: "最近一次继续教育年度",
      },
      // 优秀项目成果
      newFormName: {
        company_name: "单位名称",
        engineering: "工程名称",
        project_name: "项目部名称",
        contacts: "联系人",
        contacts_phone: "联系电话",
        achievement_name: "论文题目",
        headcount: "编制人数",

        author: "编制人姓名",
      },
      // 优质安装工程
      newFormNameThree: {
        company_name: "单位名称",
        contact_name: "联系人",
        dep: "所在部门",
        cellphone: "手机号",
        // phone: '固定电话',
        project_name: "工程名称",
        declared_project: "申报工程内容",
        construc_enp: "建设单位",
        use_enp: "使用单位",
        design_enp: "设计单位",
        supervise_enp: "监理单位",
        // participating_units:'',
      },
      // 先进企业
      newFormNameFour: {
        company_name: "单位名称",
        contacts: "联系人",
        contacts_phone: "联系人电话",
        output_value: "产值(万元)",
        contract_amount: "合同额(万元)",
        liability_ratio: "资产负债率(%)",
        profit_rate: "利润率(%)",
        growth_rate: "资产增长率(%)",
      },

      // 诚信企业
      newFormNameEight: {
        company_name: "单位名称",
        contacts_name: "申报联系人",
        contacts_post: "职务",
        contacts_phone: "电话",
        cellphone: "手机",

        liability_ratio: "资产负债率(%)",
        profit_rate: "利润率(%)",
        growth_rate: "资产增长率(%)",
      },

      // 质量小组
      newFormNameSix: {
        declaration_unit: "申报单位",
        unit_address: "单位地址",
        group_name: "小组名称",
        topic_name: "课题名称",
        course_type_name: "课程类型",
        contacts_name: "单位联系人",
        contacts_cellphone: "联系人手机",
        publisher: "发布人姓名",
        publisher_phone: "发布人手机号",
        post: "获奖工程所从事职务",
        tellphone: "本人联系电话",
        introduction: "小组简介",
      },
      // BIM申报
      newFormNameSeven: {
        declarant_name: "申报人姓名",
        declarant_post: "申报人职位",
        declarant_phone: "申报人电话",
        achievement_name: "成果名称",
        achievement_group: "成果分组",
        contacts_name: "联系人姓名",
        contacts_phone: "联系人电话",
        contacts_address: "联系地址",
        // declarant_units: '申报单位',
        leading_member: "团队成员",
      },
      // 获奖信息
      awardName: {
        0: "质量获奖情况",
        1: "安全文明情况",
      },
      // 优秀建造师
      awardNameOne: {
        0: "质量获奖情况（必填）",
        1: "安全文明情况、科技示范情况",
        2: "省级地方、行业标准",
        3: "科技奖、科技成果鉴定",
      },
      // 先进企业
      awardNameTwo: {
        0: "质量获奖情况",
        1: "",
        2: "",
        3: "安全文明情况",
        4: "",
        5: "",
        6: "科技奖、科技成功鉴定、科技示范区",
        7: "",
        8: "",
        9: "信用建设奖",
        10: "",
        11: "",
      },

      // 申报通知
      require_pdf_url: "",
      // 评选标准
      selection_pdf_url: "",

      // 资料上传内容
      uploadData: "",
      // 意见反馈原始数据
      originList: [],
      // 上传文件列表
      uploadList: [],
      // 模板下载
      modelList: [],

      pdbForm: {
        basic_quality: "",
        net_assets: "",
        project_settle_income: "",
        growth_rate: "",
        liability_ratio: "",
        profit_rate: "",
        good_msg: "",
        bad_msg: "",
        enp_management: "",
        project_app_num: "",
      },
      // 基本信息表单
      levelOne: {
        company_name: "",
        contact_name: "",
        dep: "",
        cellphone: "",
        phone: "",
        project_name: "",
        declared_project: "",
        construc_enp: "",
        use_enp: "",
        design_enp: "",
        supervise_enp: "",
      },
    };
  },
  components: {
    labelInput,
    scoreDialog,
    labelText,
    pdfVue,
    addDialog,
    feedDetail,
    normalTable,
    normalSelect,
    ChengXinCompany,
  },
  mounted() {
    // 隐藏所有el-button（这里假设你有某种方式定位到它们，比如通过class）
    this.$el.querySelectorAll(".el-button").forEach((button) => {
      // 这里可能需要根据实际情况调整，因为直接操作DOM不是Vue推荐的方式
      // 一种替代方法是控制这些按钮的显示隐藏通过v-if/v-show和数据绑定
      button.style.display = "none";
    });

    // 禁用所有input
    this.$el.querySelectorAll("input").forEach((input) => {
      input.disabled = true;
    });
  },

  created() {
    if (!this.$route.params.id) {
      this.$router.go(-1);
      return;
    }
    this.id = this.$route.params.id;
    this.getApplicationDetail();
  },
  methods: {
    safeParseFloat(value) {
      const number = parseFloat(value);
      return isNaN(number) ? 0 : number;
    },
    // 下载pdf模板
    downLoadFile() {
      if (!this.project_app_num) {
        this.$message.error("请先提交基本信息");
        return;
      }
      const url = `${API_DOMAIN}/proapi/down/download-basic-msg?type=${
        this.project.project_type
      }&project_app_num=${this.project_app_num}&project_name=${
        this.project.project_name
      }&year=2026`;
      window.open(url);
    },
    // 保存的图片删除
    deleteUpload(key, index) {
      this.$confirm("此操作将删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.uploadList[index].splice(key, 1);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    calsum() {},
    // 保存基本信息
    async setBasicInfo() {
      // 基本信息申报
      const params = {
        ...this.levelOne,
      };
      // 验证各个工程的表单
      if (this.requireSubmit(params, this.formName)) {
        return;
      }
      // 优质安装工程
      let newAddList = [...this.addList, ...this.oldAddList];
      for (let item in newAddList) {
        if (!newAddList[item].name || !newAddList[item].type) {
          this.$message.error("参建单位未填写完整");
          return;
        }
      }
      params.participating_units = JSON.stringify(newAddList);
      params.project_app_num = this.project_app_num;
      await setBasicProgram({
        data: params,
        success: (res) => {
          console.log(res);
          if (res.code === 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
          } else {
            this.$message.error(res.msg);
          }
        },
      });
    },
    // 上传文件附件保存
    async setUploadFile() {
      let newArray = this.uploadList.filter(function(s) {
        return s && s.length;
      });
      if (!newArray.length) {
        this.$message.error("请先上传文件");
        return;
      }
      if (newArray.length < 2) {
        this.$message.error("至少上传两条");
        return;
      }
      let dataJson = [];
      this.uploadList.forEach((items, key) => {
        items.forEach((item, index) => {
          let data = {};
          data["data_name"] = item.name ? item.name : item.data_name;
          data["type"] = key + 1;
          data["stored_path"] = item.url ? item.url : item.stored_path;
          dataJson.push(data);
        });
      });
      const params = {
        dataJson: dataJson,
        project_app_num: this.project_app_num,
      };
      await getUploadFile({
        data: params,
        success: (res) => {
          console.log(res);
          if (res.code === 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
          } else {
            this.$message.error(res.msg);
          }
        },
      });
    },
    // 获取必填警示
    requireSubmit(params, nameList) {
      //如果数据是对象形式
      let upString = [];
      Object.keys(params).forEach((item, index) => {
        if (
          params[item] == "" ||
          params[item] == undefined ||
          params[item] == null
        ) {
          if (nameList[item]) {
            upString.push(item);
          }
        }
      });
      if (!upString.length) {
        return false;
      } else {
        this.$message.error(`${nameList[upString[0]]}未填写`);
        return true;
      }
      // 如果数据是数组形式
    },
    // 新增行
    addInstall() {
      this.addList.push({});
    },
    // 删除行
    deleteList(index, type) {
      const number = this.addList.length + this.oldAddList.length;
      if (number === 1) {
        this.$message.error(`至少填写一条参建信息`);
        return;
      }
      if (type === "1") {
        // 例旧信息
        this.oldAddList.splice(index, 1);
      } else {
        this.addList.splice(index, 1);
      }
    },

    typeThreeInput(e, type, index) {
      if (type == "1") {
        this.addList[index].type = e;
      } else {
        this.addList[index].name = e;
      }
    },
    labelInput(e, name) {
      this.levelOne[name] = e;
    },
    // 接受子组件事件
    reciveClick(e) {
      const { list, key } = e;
      if (list === "修改") {
        this.changeInput = true;
        this.$message({
          message: "现在可以重新修改",
          type: "success",
        });
        this.$nextTick(() => {
          this.dataList = JSON.parse(JSON.stringify(this.allList));
        });
        setTimeout(() => {
          this.navIndex = 2;
        }, 1000);
      } else if (list === "我已修改") {
        this.$confirm("确认提交修改", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            // 我已修改
            sureUpdate({
              data: {
                id: this.codeList[key],
              },
              success: (res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  this.getApplicationDetail();
                  this.changeInput = false;
                } else {
                  this.$message.error(res.msg);
                }
              },
            });
          })
          .catch(() => {});
      } else {
        //查看详情
        this.$refs.feedDetail.showDetail(this.originList[key]);
      }
    },

    navTo(item) {
      let newUrl = item.stored_path ? item.stored_path : item.url;
      window.open(newUrl);
      // document.location.href = newUrl
    },
    // 获取目录
    async getProjectList(type) {
      await getDataItem({
        data: {
          type,
          year: 2026,
        },
        success: (res) => {
          // console.log('上传资料详情', res)
          this.uploadData = res.data;
        },
      });
    },
    // 切换tab栏/
    changeTab(index) {
      this.navIndex = index;
    },
    // 获取详情
    async getApplicationDetail() {
      await getApplicationDetail({
        data: {
          id: this.id,
        },
        success: (res) => {
          console.log("res", res);
          this.project_code = res.data.project.project_code;
          this.project_app_num = res.data.basicMsg.project_application_id;
          this.valForm = JSON.parse(res.data.basicMsg.pa_evaluate.scorejson);
          this.basicMsg = JSON.parse(res.data.basicMsg.basicjson);

          this.totalpoint = [
            "fen1",
            "fen2",
            "fen3",
            "fen4",
            "fen5",
            "fen6",
            "fen7",
            "fen8",
            "fen9",
            "fen10",
            "fen11",
            "fen12",
            "fen13",
            "fen14",
            "fen15",
            "fen16",
            "fen17",
            "fen18",
            "fen19",
            "fen20",
            "fen21",
            "fen22",
            "fen23",
            "fen24",
            "fen25",
            "fen26",
            "fen27",
            "fen28",
            "fen29",
            "fen30",
            "fen31",
          ].reduce(
            (sum, key) => sum + this.safeParseFloat(this.valForm[key]),
            0
          );

          // 对修改意见进行组织
          if (res.data.modify_suggest) {
            let changeList = [];
            let codeList = [];
            const dataList = res.data.modify_suggest;
            this.originList = res.data.modify_suggest;
            dataList.forEach((item) => {
              let newlist = {};
              newlist["feedback_time"] = item.feedback_time;
              if (item.suggest_content.length > 30) {
                newlist["suggest_content"] =
                  item.suggest_content.slice(0, 30) + "...";
              } else {
                newlist["suggest_content"] = item.suggest_content;
              }
              newlist["modify_status_text"] = item.modify_status_text;
              newlist["updated_at"] = item.updated_at;
              // 二级管理员 能查看
              if (item.modify_status_text === "已修改") {
                newlist["soqcol"] = ["查看详情"];
              } else {
                newlist["soqcol"] = ["查看详情", "修改", "我已修改"];
              }
              codeList.push(item.id);
              changeList.push(newlist);
            });
            this.tableList = changeList;
            this.codeList = codeList;
          }

          const uploadList = res.data.datas;
          let newUploadList = [];
          uploadList.forEach((item, index) => {
            newUploadList[Number(item.type) - 1] = [];
          });
          uploadList.forEach((item, index) => {
            newUploadList[Number(item.type) - 1].push(item);
          });
          this.uploadList = newUploadList;

          // 工程信息
          this.project = res.data.project;
          // 模板下载
          this.modelList = JSON.parse(res.data.project.distribution_materials);

          // 获奖信息
          // this.award = res.data.award
          this.award = res.data.basicMsg.pa_qualification;
          // 申报通知PDF
          this.require_pdf_url = res.data.project.require_pdf_url;
          // 评选标准PDF
          this.selection_pdf_url = res.data.project.selection_pdf_url;

          // 基本信息
          let dataList = res.data.basicMsg;
          // 将基本信息加入到即将提交的列表中
          Object.keys(dataList).forEach((item) => {
            if (this.levelOne.hasOwnProperty(item)) {
              this.levelOne[item] = dataList[item];
            }
          });

          this.allList = dataList;
          // 优秀项目经理
          if (this.project.project_type === "0") {
            this.navList = [
              "申报通知",
              "评选标准",
              "基本信息",
              "个人简历",
              "获奖信息",
              "资料上传",
            ];
          }
          // 优秀建造师
          if (this.project.project_type === "1") {
            delete this.formName.continue_edu_year;
            this.awardName = this.awardNameOne;
          }
          // 优秀项目工程成果
          if (this.project.project_type === "2") {
            this.formName = this.newFormName;
            this.navList[3] = "";
          }
          // 优质安装工程
          if (this.project.project_type === "5") {
            this.formName = this.newFormNameThree;
            this.navList[3] = "";
            this.navList[5] = "修改意见";
          }
          // 先进企业
          if (this.project.project_type === "3") {
            this.formName = this.newFormNameFour;
            this.awardName = this.awardNameTwo;
          }
          // 质量小组
          if (this.project.project_type === "6") {
            this.formName = this.newFormNameSix;
          }

          // 诚信企业
          if (this.project.project_type === "4") {
            this.formName = this.newFormNameEight;
          }

          // BIM
          if (this.project.project_type === "7") {
            this.navList[3] = "";
            this.formName = this.newFormNameSeven;
          }

          this.getProjectList(this.project.project_type);

          let newList = [];
          Object.keys(this.formName).forEach((item, index, array) => {
            const newData = {};
            newData.title = this.formName[item];
            newData.data = dataList[item];
            newList.push(newData);
          });
          // 额外处理建设单位显示
          if (this.project.project_type === "5") {
            const participating_units = JSON.parse(
              dataList.participating_units
            );
            this.oldAddList = participating_units;
          }
          // 处理BIM建设单位
          if (this.project.project_type === "7") {
            const outCode = newList[8];
            newList.splice(8, 1);
            const declarant_units = JSON.parse(dataList.declarant_units);
            declarant_units.forEach((item, index) => {
              const newData = {};
              const newData2 = {};
              newData.title = "企业类型";
              newData.data = item.type;
              newData2.title = "单位名称";
              newData2.data = item.name;
              newList.push(newData);
              newList.push(newData2);
            });
            newList.push(outCode);
          }
          this.basicInfo = newList;
        },
      });
    },
    // 模板下载弹窗
    upShow(type, index) {
      this.clickIndex = index;
      const params = {
        type,
        download: this.modelList,
      };
      this.$refs["download"].showAdd(params);
    },
    //接受点击上传回穿
    submitSuccess(e) {
      if (this.uploadList[this.clickIndex]) {
        let newList = JSON.parse(
          JSON.stringify(this.uploadList[this.clickIndex])
        );
        e.forEach((item, index) => {
          newList.push(item);
        });
        this.$set(this.uploadList, this.clickIndex, newList);
        return;
      }
      this.$set(this.uploadList, this.clickIndex, e);
    },
    // 内部评分弹窗
    showScore() {
      this.$refs["scoredialog"].showAdd("考核项目打分");
    },
  },
};
</script>

<style scoped>
/* 每个上传文件的样式 */
.inner_upload {
  position: relative;
  min-height: 40px;
  margin: 0 10px;
  /* width: 100px; */
  /* overflow: scroll; */
}

.inner_upload p {
  color: #1890ff;
}

.inner_upload img {
  border-radius: 50%;
  position: absolute;
  right: 0;
  top: 0;
  width: 15px;
  height: 15px;
  cursor: pointer;
}

.newTab {
  margin: 20px;
}

/* 上传样式 */
.uploadBtn {
  margin-top: 60px;
  margin-bottom: 60px;
  display: flex;
  margin-left: 41.5%;
  /* margin-left: 695px; */
}

.uploadBtn button {
  width: 140px;
}

.uploadHead {
  display: flex;
  position: absolute;
  align-items: center;
  left: 255px;
}

.uploadHead p {
  margin-left: 10px;
  color: #1890ff;
  cursor: pointer;
}

.uploadList {
  border: 1px solid #f0f0f0;
  width: 90%;
  margin-top: 30px;
  margin-left: 5%;
}

.uploadList_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 40px;
  padding: 0 40px 0 10px;
  line-height: 40px;
  font-size: 14px;
  flex-wrap: wrap;
  border-bottom: 1px solid #f0f0f0;
}

.uploadList_head p {
  text-align: left;
}

.head_list {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.head_list p {
  margin-left: 10px;
}

.head_list p:hover {
  color: #1890ff;
  text-decoration: underline;
}

.uploadList_mid {
  width: 90%;
  min-height: 30px;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  align-content: space-around;
  justify-content: flex-start;
}

.uploadList_mid p {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  text-align: left;
  text-indent: 2em;
  padding: 10px;
}

.uploadList_bot {
  width: 70%;
  min-height: 30px;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  align-content: space-around;
  justify-content: flex-start;
}

.uploadList_bot p {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  color: #1890ff;
  text-decoration: underline;
  margin: 0 20px;
  cursor: pointer;
}

/* 上传样式 */
.uploadContent {
  padding-bottom: 60px;
}

.inputList {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}

.titleLeft {
  margin-left: 50px;
}

.view_head {
  font-size: 18px;
  font-weight: 600;
  margin-top: 20px;
}

.midflex {
  display: flex;
  width: 90%;
  height: 50px;
  margin-left: 5%;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #eee;
}

.newAddBtn {
  width: 100%;
  display: flex;
  height: 70px;
  align-items: center;
  justify-content: center;
}

.headView {
  display: flex;
  flex-flow: column;
  align-items: flex-start;
}

.headView_top {
  width: 1350px;
  display: flex;
  justify-content: space-between;
}

.headView_top button {
  width: 100px;
  height: 35px;
  background-color: #1890ff;
  color: white;
  line-height: 35px;
  cursor: pointer;
}

.applyTitle {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #000000;
}

.headClass {
  display: flex;
  margin-top: 10px;
}

.headClass p {
  margin-right: 40px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}

/* 申报 */
.content_view {
  margin-top: 20px;
  max-width: 1350px;
  min-height: 350px;
  display: flex;
  border: 1px solid #f0f0f0;
}

.contentLeft {
  width: 200px;
}

.contentLeft p {
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  color: #333333;
  background-color: #fafafa;
  cursor: pointer;
}

.contentRight {
  width: 100%;
}

.tabActive {
  background: #e6f7ff !important;
  color: #6ea7ff !important;
  border-right: 2px solid #0077ff;
}

.content_btn {
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  margin-bottom: 30px;
}

.content_btn p {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fe2c54;
}

.content_btn button {
  width: 150px;
  margin-top: 40px;
  margin-left: 440px;
}

.specialView {
  width: 720px;
  display: flex;
  align-items: center;
}

.specialView input {
  margin-left: 20px;
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  letter-spacing: 1px;
  border-bottom: 1px solid #dbdbdb;
}

.specialView input::placeholder {
  color: #b5b5b5;
}

/* gridtable */
table.gridtable {
  font-family: verdana, arial, sans-serif;
  font-size: 14px;
  color: #333333;
  border-width: 1px;
  border-color: #666666;
  border-collapse: collapse;
  margin: auto;
}
table.gridtable th {
  border-width: 1px;
  padding: 12px;
  border-style: solid;
  border-color: #666666;
  background-color: #dedede;
}
table.gridtable td {
  border-width: 1px;
  padding: 22px;
  border-style: solid;
  border-color: #666666;
  background-color: #ffffff;
}

table.gridtable .el-input__inner {
  border: none;
}

/* /gridtable */
.el-button {
  display: none;
}
.newtable tr td {
  text-align: left;
  height: 60px;
  min-width: 50px;
}
</style>
